
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24","fill":"currentcolor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 10a.988.988 0 00-.024-.217l-1.3-5.868A4.968 4.968 0 0017.792 0H6.208a4.968 4.968 0 00-4.88 3.915L.024 9.783A.988.988 0 000 10v1a3.984 3.984 0 001 2.643V19a5.006 5.006 0 005 5h12a5.006 5.006 0 005-5v-5.357A3.984 3.984 0 0024 11zm-22 .109l1.28-5.76A2.982 2.982 0 016.208 2H7v3a1 1 0 002 0V2h6v3a1 1 0 002 0V2h.792a2.982 2.982 0 012.928 2.349l1.28 5.76V11a2 2 0 01-2 2h-1a2 2 0 01-2-2 1 1 0 00-2 0 2 2 0 01-2 2h-2a2 2 0 01-2-2 1 1 0 00-2 0 2 2 0 01-2 2H4a2 2 0 01-2-2zM18 22H6a3 3 0 01-3-3v-4.127A3.978 3.978 0 004 15h1a3.99 3.99 0 003-1.357A3.99 3.99 0 0011 15h2a3.99 3.99 0 003-1.357A3.99 3.99 0 0019 15h1a3.978 3.978 0 001-.127V19a3 3 0 01-3 3z"}})])
          )
        }
      }
    